import { Injectable } from '@angular/core';
import { retry, catchError, map } from 'rxjs/operators';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { CommonEventService } from './common-event.service';
import { ApiService } from './api.service';
import {
  context,
  trace,
  propagation,
  SpanStatusCode,
} from '@opentelemetry/api';
import { getTracer } from './apm-opentelemetry-config';

@Injectable()
export class ApiInterceptorInterceptor implements HttpInterceptor {

  constructor(public commonService:CommonEventService, public apiServe:ApiService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // let headers:any = {
    //   'Content-Type': 'application/json',
    //   'X-Trace-ID' : this.commonService.commonMainObj.fileId
    // };
    // if (localStorage.getItem('token')) {
    //     headers['Authorization'] = 'Bearer ' + this.apiServe.apiMainObj.authorization;
    // }
    // request = request.clone({
    //     setHeaders: headers
    // });
    // const modifiedRequest = request.clone({
    //   setHeaders: {
    //     'X-Trace-ID': this.commonService.commonMainObj.fileId,
    //   },
    // });
    // return next.handle(modifiedRequest)
    const tracer = getTracer();
    // Get the current active context
    const activeContext = context.active();

    const currentSpan = tracer.startSpan(
      `HTTP ${request.method} ${request.url}`
    );
    currentSpan.setAttribute('service.name', 'oneflow-frontend');
    const spanContext = currentSpan.spanContext();
    // Set the span into the current context
    const ctx = trace.setSpan(context.active(), currentSpan);
    // If there's an active span, inject the context into the request headers

    if (spanContext) {
      let updatedHeaders = request.headers
      
        // .set('sierra-trace-id', spanContext.traceId)
        // .set('sierra-span-id', spanContext.spanId);
      // ✅ Create a plain object as carrier
      const carrier: Record<string, string> = {};
      propagation.inject(ctx, carrier);
      carrier['sierra-trace-id'] = currentSpan.spanContext().traceId;
      carrier['sierra-span-id'] = currentSpan.spanContext().spanId;

      Object.entries(carrier).forEach(([key, value]) => {
        updatedHeaders = updatedHeaders.set(key, value);
      });
      request = request.clone({
        headers: updatedHeaders,
      });
    }
    const skipUrls = [
      '/superAPI'
    ]
    if(skipUrls.some(url => request.url.includes(url)) || request.method == "DELETE"){
      return next.handle(request)
    }
    return next.handle(request)
    .pipe(
      map((event:HttpEvent<any>)=>{
        if(event instanceof HttpResponse){
          if(window.location.host != 'localhost:4200'){
            if(window.location.pathname != "/ad-dashboard" && event.body == 0 || event.body.status == 0){
              this.commonService.alertCall('Alert!!','Session expired!!');
              this.commonService.goBack();
            }
            currentSpan.setAttribute('http.status_code', event.status);
            currentSpan.setStatus({
              code: SpanStatusCode.OK,
              message: 'Request successful',
            });
            currentSpan.end();
          }else{
            if(event.body.status == 0){
              event.body.status = 1
            }
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse)=>{
        // this.commonService.alertCall('Alert!!',error.message);
        currentSpan.recordException(error);
        currentSpan.setStatus({
          code: SpanStatusCode.ERROR,
          message: error.message,
        });
        currentSpan.end();
        return throwError(() => error.message);
      }))
  }
}
